import { render } from "./App.vue?vue&type=template&id=4b1afe8d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4b1afe8d&lang=scss"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-dz-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__